import React, { useEffect, useState } from "react";
import {
    Paper,
    Typography,
    Box,
    Divider,
    CircularProgress,
    Stack,
    Chip
} from "@mui/material";

import { ref, onValue } from "firebase/database";
import { rtdb } from "../../services/firebase";

export default function Messages() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const messagesRef = ref(rtdb, "messages");

        const unsubscribe = onValue(messagesRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();

                const formatted = Object.entries(data)
                    .map(([id, value]) => ({
                        id,
                        ...value,
                    }))
                    .sort((a, b) => b.createdAt - a.createdAt);

                setMessages(formatted);
            } else {
                setMessages([]);
            }

            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <Paper sx={{ ml: 32, p: 4, borderRadius: 3 }}>
            <Typography variant="h4" gutterBottom>
                Mensagens recebidas
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={3}>
                Contatos enviados pelo formulário do site
            </Typography>

            <Divider sx={{ mb: 3 }} />

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                    <CircularProgress />
                </Box>
            )}

            {!loading && messages.length === 0 && (
                <Typography>Nenhuma mensagem recebida.</Typography>
            )}

            <Stack spacing={3}>
                {messages.map((msg) => (
                    <Paper
                        key={msg.id}
                        variant="outlined"
                        sx={{ p: 3, borderRadius: 2 }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <Typography variant="h6">
                                {msg.assunto}
                            </Typography>

                            <Chip
                                label={msg.createdAtFormatted}
                                size="small"
                                variant="outlined"
                            />
                        </Box>

                        <Typography variant="body2" color="var(--cinza)">
                            {msg.nome} — {msg.email}
                        </Typography>

                        <Divider sx={{ my: 2 }} />

                        <Typography variant="body1">
                            {msg.mensagem}
                        </Typography>
                    </Paper>
                ))}
            </Stack>
        </Paper>
    );
}
